import { useEffect, useState } from "react";
import { Box, Button, Tab, TableContainer, Tooltip } from "@mui/material";
import { get, post } from "../../redux/ApiHelper";
import { TrialClassType } from "../../interfaces/trial-class.interface";
import TableComponent from "../../components/table/TableComponent";
import { Column } from "../../interfaces/table.interface";
import { errorToast, successToast } from "../../utils/toast.util";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import TrialClassPayoutHistory from "./TrialClassPayoutHistory";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import RejectModal from "./RejectModal";
import ConferenceModal from "./ConferenceModal";

const TrialClassPage = () => {
  const [trialClasses, setTrialClasses] = useState<TrialClassType[]>([]);
  const [filteredTrialClasses, setFilteredTrialClasses] = useState<
    TrialClassType[]
  >([]);
  const [searchQuery, setSearchQuery] = useState<string>("");
  const [verifyingMap, setVerifyingMap] = useState<Record<string, boolean>>({});

  const [isOpenRejectionModal, setIsOpenRejectionModal] =
    useState<boolean>(false);
  const [isPaymentReleased, setIsPaymentReleased] = useState(false);
  const [editData, setEditData] = useState<TrialClassType>();
  const [updatedCount, setUpdatedCount] = useState(0);
  const [isConferenceModalOpen, setIsConferenceModalOpen] = useState(false);
  const [selectedTrialClassForConference, setSelectedTrialClassForConference] = useState<TrialClassType | null>(null);

  const { signedAdmin } = useSelector((state: RootState) => state.admin);

  useEffect(() => {
    const queryParams = new URLSearchParams();
    queryParams.set("type", String(signedAdmin.type));
    queryParams.set("adminId", String(signedAdmin.id));
    get(`/admin/trial-class/all?${queryParams.toString()}`).then((res) => {
      setTrialClasses(res.trialClass);
      setFilteredTrialClasses(res.trialClass);
      setIsPaymentReleased(false);
    });
  }, [updatedCount, isOpenRejectionModal, isPaymentReleased]);

  const closeModal = () => {
    setIsOpenRejectionModal(false);
    setEditData(null);
  };
  const isEdit = true;

  const [trialClassTab, setTrialClassTab] = useState("1");

  const handleTeacherSubTabChange = (event, newValue) => {
    setTrialClassTab(newValue);
  };

  //   Function to close modal


  const handleClickApprove = async (
    trialClassId: string,
  ) => {
    try {
      post(`/admin/trial-class/approved/${trialClassId}`, { email: signedAdmin.email, role: signedAdmin.role, type: signedAdmin.type }).then(
        (res) => {
          successToast(res.message);
          setUpdatedCount(updatedCount + 1);
        }
      );
    } catch (error) {
      console.log(error);
    }
  };



  const handleSearch = (query: string) => {
    setSearchQuery(query);
    const lowerQuery = query.toLowerCase();

    const filteredList = trialClasses?.filter((tc) => {
      const teacherName = tc.requestedTeacherId?.name?.toLowerCase() || "";
      const parentName = tc.parentId?.name?.toLowerCase() || "";
      const studentName = tc.studentId.name?.toLowerCase() || "";
      return (
        tc._id.includes(lowerQuery) ||
        teacherName.includes(lowerQuery) ||
        parentName.includes(lowerQuery) ||
        studentName.includes(lowerQuery)
      );
    });

    setFilteredTrialClasses(filteredList);
  };

  const columns: Column[] = [
    { select: "securedCoins", header: "Secured coins" },
    {
      header: "Parent name",
      render: (_value: any, row: TrialClassType) => row?.parentId.name || "N/A",
    },
    {
      header: "Student name",
      render: (_value: any, row: TrialClassType) =>
        row?.studentId.name || "N/A",
    },
    {
      header: "Teacher name",
      render: (_value: any, row: TrialClassType) =>
        row?.requestedTeacherId.name || "N/A",
    },
    {
      header: "CreatedAt",
      render: (_value: any, row: TrialClassType) =>
        new Date(row?.createdAt).toLocaleString() || "N/A",
    },
    //approve or reject request
    //release payment

    {
      header: "Admin Approve or reject Status",
      render: (_value: any, row: TrialClassType) => {
        let badgeColor = "";

        switch (row?.isAdminApproved) {
          case "approved":
            badgeColor = "bg-green-500";
            break;
          case "pending":
            badgeColor = "bg-yellow-500";
            break;
          case "rejected":
            badgeColor = "bg-red-500";
            break;
          default:
            badgeColor = "bg-gray-400"; // fallback color
        }

        return (
          <div className="flex items-center">
            <span
              className={`status-badge ${badgeColor} text-white px-2 py-1 rounded`}
            >
              {row?.isAdminApproved}
            </span>
          </div>
        );
      },
    },
    {
      header: "Approve or reject Action",
      render: (_value: any, row: TrialClassType) => {
        const isCompleted = row?.isAdminApproved === "pending";
        return (
          <div className="flex items-center">
            {isCompleted && (
              <div>
                {" "}
                <Button
                  className=""
                  color="success"
                  sx={{ background: "inherit" }}
                  onClick={() => {
                    handleClickApprove(row._id);
                  }}
                >
                  Accept
                </Button>
                <Button
                  className=""
                  color="error"
                  sx={{ background: "inherit" }}
                  onClick={() => {
                    setEditData(row);
                    setIsOpenRejectionModal(true);
                  }}
                >
                  Reject
                </Button>
              </div>
            )}
          </div>
        );
      },
    },
    {
      header: "Payment release to teacher",
      render: (_value: any, row: TrialClassType) => {
        const isProcessing = verifyingMap[row._id];

        const handleRelease = async () => {
          setVerifyingMap((prev) => ({ ...prev, [row._id]: true }));
          post(`/admin/trial-class/transfer-teacher/${row._id}`, {})
            .then((response) => {
              const { payout, message } = response;

              const updatedList = trialClasses.map((OldPayout) =>
                OldPayout._id === row._id
                  ? { ...OldPayout, ...payout }
                  : OldPayout
              );
              setTrialClasses(updatedList);
              setFilteredTrialClasses(updatedList);
              setIsPaymentReleased(true);
              successToast(
                message || "Coin release successfully to the teacher"
              );
            })
            .catch(() =>
              errorToast("Failed to proceed transfer. Please try again.")
            )
            .finally(() => {
              setVerifyingMap((prev) => ({ ...prev, [row._id]: false }));
            });
        };

        return (
          <div className="flex items-center flex-col space-y-4">
            {!row?.isPaymentReleasedToTeacher &&
              !row?.isPaymentReleasedBackToParent &&
              !(row.isAdminApproved === "pending") &&
              !(row.isAdminApproved === "rejected") ? (
              <div className="ml-2">
                <Tooltip
                  title="Click release to procceed the transaction"
                  placement="top"
                >
                  <button
                    className={`text-white px-3 py-1 rounded whitespace-nowrap ${isProcessing
                      ? "bg-blue-300 cursor-not-allowed"
                      : "bg-blue-500 hover:bg-blue-600"
                      }`}
                    onClick={handleRelease}
                    disabled={isProcessing}
                    aria-label="Release Payment"
                  >
                    {isProcessing
                      ? "Releasing..."
                      : "Release payments to teachers"}
                  </button>
                </Tooltip>
              </div>
            ) : (
              row?.isPaymentReleasedToTeacher && (
                <span className="bg-blue-500 p-1 rounded text-white">
                  Released
                </span>
              )
            )}
          </div>
        );
      },
    },
    {
      header: "Payment release back to parent",
      render: (_value: any, row: TrialClassType) => {
        const isProcessing = verifyingMap[row._id];

        const handleRelease = async () => {
          setVerifyingMap((prev) => ({ ...prev, [row._id]: true }));
          post(`/admin/trial-class/transfer-parent/${row._id}`, {})
            .then((response) => {
              const { payout, message } = response;

              const updatedList = trialClasses.map((OldPayout) =>
                OldPayout._id === row._id
                  ? { ...OldPayout, ...payout }
                  : OldPayout
              );
              setTrialClasses(updatedList);
              setFilteredTrialClasses(updatedList);
              setIsPaymentReleased(true);
              successToast(
                message || "Coin release successfully to the parent"
              );
            })
            .catch(() =>
              errorToast("Failed to proceed transfer. Please try again.")
            )
            .finally(() => {
              setVerifyingMap((prev) => ({ ...prev, [row._id]: false }));
            });
        };

        return (
          <div className="flex items-center flex-col space-y-4">
            {!row.isPaymentReleasedToTeacher &&
              !row?.isPaymentReleasedBackToParent &&
              !(row.isAdminApproved === "pending") ? (
              <div className="ml-2">
                <Tooltip
                  title="Click release to procceed the transaction"
                  placement="top"
                >
                  <button
                    className={`text-white px-3 py-1 rounded whitespace-nowrap ${isProcessing
                      ? "bg-blue-300 cursor-not-allowed"
                      : "bg-orange-500 hover:bg-orange-600"
                      }`}
                    onClick={handleRelease}
                    disabled={isProcessing}
                    aria-label="Release Payment"
                  >
                    {isProcessing
                      ? "Releasing..."
                      : "Release coins back to parents"}
                  </button>
                </Tooltip>
              </div>
            ) : (
              row?.isPaymentReleasedBackToParent && (
                <span className="bg-blue-500 p-1 rounded text-white">
                  Released
                </span>
              )
            )}
          </div>
        );
      },
    },
    {
      header: "Time",
      render: (_value: any, row: TrialClassType) => {
        const index = row?.teacherSelectedTimeIndex;
        return (
          <div className="min-w-[150px]">
            {typeof index === "number" &&
              `date: ${new Date(row?.times[index].date).toDateString()} from: ${row?.times[index].from
              } to: ${row?.times[index].to}`}
          </div>
        );
      },
    },
    {
      header: "Teacher Status",
      render: (_value: any, row: TrialClassType) => {
        let badgeColor = "";

        switch (row?.teacherAction) {
          case "accepted":
            badgeColor = "bg-green-500";
            break;
          case "pending":
            badgeColor = "bg-yellow-500";
            break;
          case "rejected":
            badgeColor = "bg-red-500";
            break;
          default:
            badgeColor = "bg-gray-400"; // fallback color
        }

        return (
          <div className="flex items-center">
            <span
              className={`status-badge ${badgeColor} text-white px-2 py-1 rounded`}
            >
              {row?.teacherAction}
            </span>
            {row?.teacherAction === "accepted" && row?.isAdminApproved === "approved" && (
              <button
                className="bg-green-500 p-1 rounded text-white ml-2 whitespace-nowrap"
                onClick={() => {
                  setSelectedTrialClassForConference(row);
                  setIsConferenceModalOpen(true);
                }}
              >
                Join now
              </button>
            )}
          </div>
        );
      },
    },
  ];

  return (
    <div className="max-w-[100vw] overflow-x-hidden">
      <div className="title text-yellow-500 text-xl">Trial classes</div>
      <div className="">
        <TabContext value={trialClassTab}>
          <Box
            className="mb-3"
            sx={{ borderBottom: 1, borderColor: "divider" }}
          >
            <TabList
              onChange={handleTeacherSubTabChange}
              aria-label="Teacher subtabs"
              sx={{
                "& .MuiTab-root": {
                  color: "var(--color-light-gray)",
                  "&:hover": {
                    color: "var(--color-primary)!important",
                    backgroundColor: "rgba(0, 0, 0, 0.1)",
                    borderRadius: "8px 8px 0 0",
                  },
                },
                "& .Mui-selected": {
                  color: "var(--color-primary)!important",
                  backgroundColor: "rgba(0, 0, 0, 0.1)",
                  fontWeight: "bold",
                  borderRadius: "8px 8px 0 0",
                },
                "& .MuiTabs-indicator": {
                  backgroundColor: "var(--color-primary)",
                },
              }}
            >
              <Tab label="Trial class request" value="1" />
              {signedAdmin.type === "franchise" ? null : (
                <Tab label="Payout request" value="2" />
              )}
            </TabList>
          </Box>
          <TabPanel value="1">
            <TableContainer>
              <div className="search-container mb-4">
                <input
                  type="text"
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 text-gray-700"
                  placeholder="Search trial classes"
                  value={searchQuery}
                  onChange={(e) => handleSearch(e.target.value)}
                />
              </div>
              <div className="overflow-x-auto max-w-[100vw]">
                <TableComponent
                  columns={columns.filter((item) => {
                    if (
                      signedAdmin.type === "franchise" &&
                      (item.header === "Approve or reject Action" ||
                        item.header === "Payment release to teacher" ||
                        item.header === "Payment release back to parent")
                    ) {
                      return false;
                    } else {
                      return true;
                    }
                  })}
                  data={filteredTrialClasses}
                />
              </div>
              <RejectModal
                isOpen={isOpenRejectionModal}
                closeModal={closeModal}
                isEdit={isEdit}
                editData={editData}
                onSuccess={() => {
                  setUpdatedCount(updatedCount + 1);
                }}
              />
              <ConferenceModal
                isOpen={isConferenceModalOpen}
                onClose={() => {
                  setIsConferenceModalOpen(false);
                  setSelectedTrialClassForConference(null);
                }}
                trialClass={selectedTrialClassForConference}
              />
            </TableContainer>
          </TabPanel>
          <TabPanel value="2">
            <TableContainer>
              <TrialClassPayoutHistory />
            </TableContainer>
          </TabPanel>
        </TabContext>
      </div>
    </div>
  );
};

export default TrialClassPage;
